module.exports = __webpack_public_path__ + "img/photo.038636c4.png";